//  ----------      START   IMPORT  BLOCK       ----------
import { useState, useEffect } from "react";
//  Config
import "./BackToTopButton.css";
//  ----------      END   IMPORT  BLOCK       ----------

function BackToTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setIsVisible(window.scrollY > 200);
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      onClick={scrollToTop}
      className={`back-to-top-btn ${isVisible ? "show" : ""}`}
      aria-label="Back to top"
    >
      ^
    </button>
  );
}

export default BackToTopButton;
